import React from 'react';

export default function DnaDomainVis(): JSX.Element {
  return (
    <>
      <path
        d="M12.7735 16.7775L13.0759 16.5527C13.519 16.2231 13.6143 15.5943 13.2886 15.1482L7.4504 7.15109C7.12476 6.70503 6.50152 6.61061 6.05836 6.9402L5.75604 7.16505M9.45936 19.2424L9.15704 19.4673C8.71389 19.7969 8.09065 19.7024 7.765 19.2564L1.92677 11.2592C1.60112 10.8132 1.69639 10.1844 2.13954 9.85478L2.44186 9.62993"
        stroke="#5F7B00"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 9.49818 13.9835)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 6.55002 9.94513)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 5.49805 16.8636)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 2.54989 12.8252)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M21.5656 28.7778L21.868 28.553C22.3111 28.2234 22.4064 27.5946 22.0807 27.1485L16.2425 19.1514C15.9168 18.7053 15.2936 18.6109 14.8505 18.9405L14.5481 19.1653M18.2515 31.2427L17.9491 31.4676C17.506 31.7971 16.8827 31.7027 16.5571 31.2567L10.7189 23.2595C10.3932 22.8134 10.4885 22.1846 10.9316 21.8551L11.234 21.6302"
        stroke="#DAF972"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 18.2903 25.9838)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 15.3421 21.9454)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 14.2901 28.8638)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 11.342 24.8255)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M59.2265 16.7775L58.9241 16.5527C58.481 16.2231 58.3857 15.5943 58.7114 15.1482L64.5496 7.15109C64.8752 6.70503 65.4985 6.61061 65.9416 6.9402L66.244 7.16505M62.5406 19.2424L62.843 19.4673C63.2861 19.7969 63.9093 19.7024 64.235 19.2564L70.0732 11.2592C70.3989 10.8132 70.3036 10.1844 69.8605 9.85478L69.5581 9.62993"
        stroke="#5F7B00"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 62.5018 13.9835)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 65.45 9.94513)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 66.502 16.8636)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 69.4501 12.8252)"
        stroke="#5F7B00"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M50.4344 28.7778L50.132 28.553C49.6889 28.2234 49.5936 27.5946 49.9193 27.1485L55.7575 19.1514C56.0831 18.7053 56.7064 18.6109 57.1495 18.9405L57.4519 19.1653M53.7485 31.2427L54.0509 31.4676C54.494 31.7971 55.1172 31.7027 55.4429 31.2567L61.2811 23.2595C61.6068 22.8134 61.5115 22.1846 61.0684 21.8551L60.766 21.6302"
        stroke="#DAF972"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 53.7097 25.9838)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 56.6579 21.9454)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 57.7099 28.8638)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 60.658 24.8255)"
        stroke="#DAF972"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M20.5887 10.7774L20.8911 10.5526C21.3342 10.223 21.4295 9.59419 21.1038 9.14812L15.2656 1.15097C14.9399 0.704904 14.3167 0.610484 13.8736 0.940077L13.5712 1.16493M17.2746 13.2423L16.9722 13.4672C16.5291 13.7967 15.9058 13.7023 15.5802 13.2563L9.74196 5.25911C9.41632 4.81305 9.51158 4.18425 9.95473 3.85466L10.2571 3.62981"
        stroke="#005B82"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 17.3134 7.98337)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 14.3652 3.94501)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 13.3132 10.8634)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 10.3651 6.82507)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M29.3808 22.7777L29.6831 22.5528C30.1263 22.2233 30.2216 21.5945 29.8959 21.1484L24.0577 13.1512C23.732 12.7052 23.1088 12.6108 22.6656 12.9404L22.3633 13.1652M26.0666 25.2426L25.7643 25.4674C25.3212 25.797 24.6979 25.7026 24.3723 25.2565L18.5341 17.2594C18.2084 16.8133 18.3037 16.1845 18.7468 15.8549L19.0491 15.6301"
        stroke="#95DAF8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 26.1055 19.9836)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 23.1573 15.9453)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 22.1053 22.8637)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 19.1572 18.8253)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M33.413 45.9997L33.7786 45.9997C34.3308 45.9997 34.7727 45.552 34.7654 44.9998L34.6339 35.0005C34.6266 34.4483 34.173 34.0006 33.6207 34.0006L33.2552 34.0006M29.3165 45.9997L28.951 45.9997C28.3987 45.9997 27.9451 45.552 27.9378 44.9998L27.8063 35.0005C27.799 34.4483 28.2409 34.0006 28.7931 34.0006L29.1587 34.0006"
        stroke="#95DAF8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.2243e-09 -0.0131528 -0.999913 32.3675 41.7685)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.94507e-10 -0.0131528 -0.999913 32.3018 36.7689)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.16947e-09 -0.0131528 -0.999913 27.4777 41.6917)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.39682e-10 -0.0131528 -0.999913 27.4119 36.6921)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M33.413 60L33.7786 60C34.3308 60 34.7727 59.5523 34.7654 59.0001L34.6339 49.0008C34.6266 48.4486 34.173 48.0009 33.6207 48.0009L33.2552 48.0009M29.3165 60L28.951 60C28.3987 60 27.9451 59.5523 27.9378 59.0001L27.8063 49.0008C27.799 48.4486 28.2409 48.0009 28.7931 48.0009L29.1587 48.0009"
        stroke="#95DAF8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.2243e-09 -0.0131528 -0.999913 32.3675 55.7688)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.94507e-10 -0.0131528 -0.999913 32.3018 50.7692)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.16947e-09 -0.0131528 -0.999913 27.4777 55.692)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.39682e-10 -0.0131528 -0.999913 27.4119 50.6924)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M28.3533 25.0005L30.8119 27.5361C31.1814 27.9172 31.3843 28.4294 31.3759 28.9602L31.2957 34.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M51.9057 10.7774L51.6033 10.5526C51.1602 10.223 51.0649 9.59419 51.3906 9.14812L57.2288 1.15097C57.5545 0.704904 58.1777 0.610484 58.6208 0.940077L58.9232 1.16493M55.2198 13.2423L55.5222 13.4672C55.9653 13.7967 56.5886 13.7023 56.9142 13.2563L62.7524 5.25911C63.0781 4.81305 62.9828 4.18425 62.5397 3.85466L62.2373 3.62981"
        stroke="#005B82"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 55.181 7.98337)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 58.1292 3.94501)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 59.1812 10.8634)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 62.1293 6.82507)"
        stroke="#005B82"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M43.1136 22.7777L42.8113 22.5528C42.3681 22.2233 42.2728 21.5945 42.5985 21.1484L48.4367 13.1512C48.7624 12.7052 49.3856 12.6108 49.8288 12.9404L50.1311 13.1652M46.4278 25.2426L46.7301 25.4674C47.1732 25.797 47.7965 25.7026 48.1221 25.2565L53.9604 17.2594C54.286 16.8133 54.1907 16.1845 53.7476 15.8549L53.4453 15.6301"
        stroke="#95DAF8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 46.3889 19.9836)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 49.3371 15.9453)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 50.3891 22.8637)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 53.3372 18.8253)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M39.0814 45.9997L38.7158 45.9997C38.1636 45.9997 37.7217 45.552 37.729 44.9998L37.8605 35.0005C37.8678 34.4483 38.3214 34.0006 38.8737 34.0006L39.2392 34.0006M43.1779 45.9997L43.5434 45.9997C44.0957 45.9997 44.5493 45.552 44.5566 44.9998L44.6881 35.0005C44.6954 34.4483 44.2535 34.0006 43.7013 34.0006L43.3357 34.0006"
        stroke="#95DAF8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.2243e-09 0.0131528 -0.999913 40.1269 41.7685)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.94507e-10 0.0131528 -0.999913 40.1926 36.7689)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.16947e-09 0.0131528 -0.999913 45.0168 41.6917)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.39682e-10 0.0131528 -0.999913 45.0825 36.6921)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M39.0814 60L38.7158 60C38.1636 60 37.7217 59.5523 37.729 59.0001L37.8605 49.0008C37.8678 48.4486 38.3214 48.0009 38.8737 48.0009L39.2392 48.0009M43.1779 60L43.5434 60C44.0957 60 44.5493 59.5523 44.5566 59.0001L44.6881 49.0008C44.6954 48.4486 44.2535 48.0009 43.7013 48.0009L43.3357 48.0009"
        stroke="#95DAF8"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.2243e-09 0.0131528 -0.999913 40.1269 55.7688)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.94507e-10 0.0131528 -0.999913 40.1926 50.7692)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.16947e-09 0.0131528 -0.999913 45.0168 55.692)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.39682e-10 0.0131528 -0.999913 45.0825 50.6924)"
        stroke="#95DAF8"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M44.1411 25.0005L41.6825 27.5361C41.313 27.9172 41.1101 28.4294 41.1186 28.9602L41.1987 34.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  );
}
